/**
 * Created by pajicv on 10/26/18.
 */
import React from 'react';
import OverlayContainer from '../components/Overlay/OverlayContainer';
import ProjectCycles from '../components/Cycles/ProjectCycles.enhancer';
import Task from '../components/Tasks/Task.enhancer';

const Test = () => (
    <OverlayContainer
        projectId="-LPPy66XZ3Dl-zwRdZKB"
        cycleId="-LPQ2rzk_u7Qyh_kpROj"
    />
);

export default Test;


// WEBPACK FOOTER //
// ./src/routes/Test.js